import {
  IconAward,
  IconBag,
  IconBell,
  IconBodega,
  IconBook,
  IconCalendar,
  IconCard,
  IconCart,
  type IconComponent,
  IconCrown,
  IconDocument,
  IconEye,
  IconGallery,
  IconGlass,
  IconGps,
  IconHome,
  IconInfo,
  IconLock,
  IconMap,
  IconMedal,
  IconProfile,
  IconRefresh,
  IconRoute,
  IconSettings,
  IconShop,
  IconStar,
  IconTeacher,
  IconTicket,
  IconTimer,
  IconUsers,
  IconVerify,
  IconWineBottle,
  IconWineglass,
} from '@/shared/ui';

/** Иконка пункта меню по ключу раздела — по docs/sections.md хендоффа. */
const SECTION_ICONS: Readonly<Record<string, IconComponent>> = {
  dashboard: IconHome,
  users: IconProfile,
  team: IconUsers,
  profile: IconProfile,
  countries: IconGps,
  origins: IconVerify,
  regions: IconMap,
  wineries: IconBodega,
  wines: IconWineBottle,
  sets: IconBag,
  drops: IconTimer,
  courses: IconBook,
  lessons: IconTeacher,
  tests: IconVerify,
  tastings: IconWineglass,
  calibs: IconGlass,
  excursions: IconRoute,
  trips: IconTicket,
  orders: IconCart,
  partners: IconShop,
  bookings: IconCalendar,
  deliveries: IconShop,
  xp: IconStar,
  levels: IconCrown,
  rewards: IconCard,
  tiers: IconAward,
  accuracy: IconVerify,
  specs: IconMedal,
  publications: IconDocument,
  stories: IconTimer,
  onboarding: IconGallery,
  docs: IconLock,
  brand: IconGallery,
  xplog: IconMedal,
  acclog: IconVerify,
  learnlog: IconBook,
  tastelog: IconWineglass,
  triplog: IconTicket,
  excurlog: IconRoute,
  diarylog: IconDocument,
  sublog: IconUsers,
  likelog: IconStar,
  stamplog: IconMedal,
  speclog: IconVerify,
  moderation: IconEye,
  care: IconBell,
  notifs: IconInfo,
  revenue: IconCard,
  appmarkets: IconSettings,
  audit: IconRefresh,
  // ТЗ 14.10 (в docs/sections.md хендоффа разделов нет): настройки интеграций и журнал обменов.
  integrations: IconSettings,
  integration_logs: IconDocument,
};

/** Разделы без строки в docs/sections.md и без своей иконки выше — нейтральная иконка настроек. */
const FALLBACK_ICON = IconSettings;

export function sectionIcon(key: string): IconComponent {
  return SECTION_ICONS[key] ?? FALLBACK_ICON;
}
